import { Link, Text } from '@shared/components';
import clsx from 'clsx';

export type MaintenancePageProps = {
  logoUrl?: string;
  isPlugin?: boolean;
};

export function MaintenancePage({
  logoUrl = '/logo_full.png',
  isPlugin = false,
}: MaintenancePageProps): React.ReactElement {
  return (
    <div className="flex h-screen w-screen flex-col justify-between">
      <div className="flex flex-1 flex-col items-center justify-center gap-6 pb-[10%] text-gray-700">
        <Text
          type={isPlugin ? 'body-sm' : 'body-md'}
          className="max-w-md text-center text-gray-700"
        >
          We’re tuning the engine.
        </Text>
        <img
          className="self-center"
          width={isPlugin ? '50%' : '25%'}
          src={logoUrl}
          alt="Logo"
        />

        <Text
          type={isPlugin ? 'body-sm' : 'body-md'}
          className={clsx(
            'text-center text-gray-700',
            isPlugin ? 'max-w-64' : 'max-w-md'
          )}
        >
          Our systems are getting a quick tune-up to keep things running
          smoothly. We’ll be back shortly — thanks for your patience.
        </Text>
      </div>
      <div className="flex flex-wrap justify-center gap-4 p-2">
        <Link size={isPlugin ? 'xs' : 'small'} href="https://www.vooma.com/">
          Vooma
        </Link>
        <Link size={isPlugin ? 'xs' : 'small'} href="https://status.vooma.com/">
          Status Page
        </Link>
        <Link
          size={isPlugin ? 'xs' : 'small'}
          href="https://www.vooma.com/terms-of-service"
        >
          Terms of Service
        </Link>
        <Link
          size={isPlugin ? 'xs' : 'small'}
          href="https://www.vooma.com/privacy-policy"
        >
          Privacy Policy
        </Link>
      </div>
    </div>
  );
}
